import { render, staticRenderFns } from "./SearchInvoices.vue?vue&type=template&id=64b1d970&scoped=true"
import script from "./SearchInvoices.vue?vue&type=script&lang=js"
export * from "./SearchInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1d970",
  null
  
)

export default component.exports